import { db, Timestamp, } from "@/firebase/config"
import { collection, addDoc } from "firebase/firestore"
import { BlogMessage, BlogMessageConverter } from "@/firebase/models/blog_message_model"

/**
 * Class to add mock blogs
 */
const addMockBlogs = () => {
    
    /**
     * Adds the mock Blogs
     * @returns {Promise<void>}
     */
    const addBlogs = async () => {
        for (const blog of _createMockBlogs()) {
            await addDoc(collection(db, 'Blog').withConverter(BlogMessageConverter), blog)
        }
    }

    /**
     * @returns {}
     */
    function _createMockBlogs() {
        return [
            new BlogMessage(
                'John Doe',
                Timestamp.now(),
                'Hi, how are you?',
            ),
            new BlogMessage(
                'John Doe',
                Timestamp.now(),
                'I\'m fine. How are you?',
            ),
        ]
    }

    return { addBlogs }
}

export default addMockBlogs
